<!--Add Instagram URL Details-->
<template>
  <v-dialog
    v-model="instagramReelsDialog"
    persistent
    fullscreen
  >
    <v-card>
      <v-toolbar dense elevation="0" dark color="accent">
        <v-toolbar-title v-if="requestType === 'edit'">Update the URL of any post or reel</v-toolbar-title>
        <v-toolbar-title v-else>Add the URL of any post or reel</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card elevation="0">
      <v-card-text>
        <form class="pt-2" autocomplete="off" @submit.prevent="addUpdateInstagramUrl">
          <v-row>
            <template v-if="requestType === 'edit'">
              <v-card elevation="0">
                <v-card-text>
                  <v-row no-gutters>
                    <v-col cols="12" md="12" lg="12" xs="12" sm="12">
                      <v-card
                        v-for="(item, index) in instaUrlsArray"
                        :key="`instagram_URL_Field_${index}`"
                        outlined
                        elevation="0"
                      >
                        <v-card-text>
                          <v-row no-gutters>
                            <v-col cols="12" md="11" lg="11" xs="11" sm="11">
                              <v-text-field
                                  dense
                                  outlined
                                  v-model="item.url"
                                  hide-details
                                  :error="item.invalid || item.isError"
                                >
                                  <template v-slot:label>
                                    Enter instagram Reel/Post URL<span style="color: red;">*</span>
                                  </template>
                                </v-text-field>
                            </v-col>
                            <v-col class="mt-3" cols="12" md="11" lg="11" xs="11" sm="11">
                              <v-combobox
                                  :items="franchiseeList"
                                  item-text="companyName"
                                  chips
                                  multiple
                                  clearable
                                  dense
                                  outlined
                                  v-model="item.franchiseeNames"
                                  return-object
                                  @change="checkAllFranchiseeSelecte(item)"
                                  hide-details
                                >
                                  <template v-slot:prepend-item>
                                    <v-checkbox
                                      class="ml-4 text-body-2"
                                      v-model="item.isSelectAll"
                                      @click="selectAllFranchisee(item)"
                                      hide-details
                                      ripple

                                    >
                                      <template v-slot:label>
                                        <span class="text-body-2"> Select All Franchisee </span>
                                      </template>
                                    </v-checkbox>
                                    <v-divider />
                                  </template>
                                  <template v-slot:selection="{ attrs, item, parent, selected }">
                                    <v-chip
                                      v-if="item === Object(item)"
                                      v-bind="attrs"
                                      small
                                      class="my-1"
                                    >
                                      <span class="pr-2">
                                        {{ item.companyName }}
                                      </span>
                                      <v-icon
                                        small
                                        @click="parent.selectItem(item)"
                                      >
                                        mdi-close
                                      </v-icon>
                                    </v-chip>
                                  </template>
                                  <template v-slot:label>
                                    <div>
                                      <span>Search & Select Franchisee</span>
                                      <span class="error--text">*</span>
                                    </div>
                                  </template>
                                </v-combobox>
                            </v-col>
                            <v-col class="mt-2 pr-2" cols="12" md="7" lg="7" xs="6" sm="6">
                              <insta-custom-date-picker
                                outlined
                                hide-details
                                placeholder=""
                                label="From Date"
                                :single-line="false"
                                dense
                                :minToDate="minStartDate"
                                :maxToDate="maxDate"
                                @change="onStartDateChange(item)"
                                v-model="item.fromDate"
                                />
                            </v-col>
                            <v-col class="mt-2" cols="12" md="4" lg="4" xs="6" sm="6">
                              <v-menu
                                :ref="`frommenu${index}`"
                                v-model="item.time1"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="item.fromtime"
                                transition="scale-transition"
                                offset-y
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    outlined
                                    dense
                                    v-model="item.fromtime"
                                    aria-required="true"
                                    label="Start Time"
                                    readonly
                                    v-bind="attrs"
                                    hide-details
                                    v-on="on"
                                    class="py-1 my-0"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="item.time1"
                                  v-model="item.fromtime"
                                  full-width
                                  :min="item.fromDate === currentDate ? currentTime : ''"
                                  @change="onStartTimeChange(item)"
                                  format="24hr"
                                  @click:minute="updateTime(item, index, 'frommenu')"
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                            <v-col class="mt-2 pr-2" cols="12" md="7" lg="7" xs="6" sm="6">
                              <insta-custom-date-picker
                                outlined
                                placeholder=""
                                label="End Date"
                                :single-line="false"
                                dense
                                @change="onEndDateChange(item)"
                                :minToDate="item.fromDate"
                                v-model="item.toDate"
                              />
                            </v-col>
                            <v-col class="mt-2" cols="12" md="4" lg="4" xs="6" sm="6">
                              <v-menu
                                :ref="`tomenu${index}`"
                                v-model="item.menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="item.totime"
                                transition="scale-transition"
                                offset-y
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    class="py-1 my-0"
                                    v-model="item.totime"
                                    aria-required="true"
                                    label="End Time"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    dense
                                    outlined
                                    hide-details
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="item.menu2"
                                  v-model="item.totime"
                                  full-width
                                  format="24hr"
                                  :min="item.toDate === item.fromDate ? item.fromtime : ''"
                                  @click:minute="updateTime(item, index, 'tomenu')"
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          <template v-else>
          <v-col cols="12" md="12">
            <v-card elevation="0">
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    lg="12"
                    xs="12"
                    sm="12"
                    v-for="(item, index) in instaUrlsArray"
                    :key="`instagram_URL_Field_${index}`"
                  >
          <v-card outlined>
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="11" lg="11" xs="11" sm="11">
                  <v-text-field
                    dense
                    outlined
                    v-model="item.url"
                    hide-details
                    :error="item.invalid || item.isError"
                  >
                    <template v-slot:label>
                      Enter instagram Reel/Post URL<span style="color: red;">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  class="d-flex justify-center align-center"
                  cols="12"
                  md="1"
                  lg="1"
                  xs="1"
                  sm="1"
                >
                  <v-btn
                    v-if="index === instaUrlsArray.length - 1 && instaUrlsArray.length < 10"
                    color="accent"
                    @click="createInstaUrlArray"
                    x-small
                    dense
                    fab
                    rounded
                    text
                  >
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    color="red"
                    @click="removeInstaUrl(index)"
                    x-small
                    dense
                    fab
                    rounded
                    text
                  >
                    <v-icon small>mdi-minus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="mt-3" no-gutters>
                <v-col cols="12" md="11" lg="11" xs="11" sm="11">
                  <v-combobox
                    :items="franchiseeList"
                    item-text="companyName"
                    chips
                    multiple
                    clearable
                    dense
                    outlined
                    v-model="item.franchiseeNames"
                    return-object
                    @change="checkAllFranchiseeSelecte(item)"
                    hide-details
                    :error="item.isFranchiseeError"
                  >
                    <template v-slot:prepend-item>
                      <v-checkbox
                        class="ml-4 text-body-2"
                        v-model="item.isSelectAll"
                        @click="selectAllFranchisee(item)"
                        hide-details
                        ripple
                      >
                        <template v-slot:label>
                          <span class="text-body-2"> Select All Franchisee </span>
                        </template>
                      </v-checkbox>
                      <v-divider />
                    </template>
                    <template v-slot:selection="{ attrs, item, parent, selected }">
                      <v-chip
                        v-if="item === Object(item)"
                        v-bind="attrs"
                        small
                        class="my-1"
                      >
                        <span class="pr-2">
                          {{ item.companyName }}
                        </span>
                        <v-icon
                          small
                          @click="parent.selectItem(item)"
                        >
                          mdi-close
                        </v-icon>
                      </v-chip>
                    </template>
                    <template v-slot:label>
                      <div>
                        <span>Search & Select Franchisee</span>
                        <span class="error--text">*</span>
                      </div>
                    </template>
                  </v-combobox>
                </v-col>
              </v-row>
              <v-row class="mt-2" no-gutters>
                <v-col class="pr-2" cols="12" md="7" lg="7" xs="6" sm="6">
                  <insta-custom-date-picker
                    outlined
                    hide-details
                    placeholder=""
                    label="From Date"
                    :single-line="false"
                    dense
                    :minToDate="currentDate"
                    @change="onStartDateChange(item)"
                    v-model="item.fromDate"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4" xs="6" sm="6">
                  <v-menu
                    :ref="`frommenu${index}`"
                    v-model="item.time1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="item.fromtime"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="item.fromtime"
                        aria-required="true"
                        label="Start Time"
                        readonly
                        v-bind="attrs"
                        hide-details
                        v-on="on"
                        class="py-1 my-0"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="item.time1"
                      v-model="item.fromtime"
                      full-width
                      :min="item.fromDate === currentDate ? currentTime : ''"
                      @change="onStartTimeChange(item)"
                      format="24hr"
                      @click:minute="updateTime(item, index, 'frommenu')"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row class="mt-2" no-gutters>
                <v-col class="pr-2" cols="12" md="7" lg="7" xs="6" sm="6">
                  <insta-custom-date-picker
                    outlined
                    placeholder=""
                    label="End Date"
                    :single-line="false"
                    dense
                    @change="onEndDateChange(item)"
                    :minToDate="item.fromDate"
                    v-model="item.toDate"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4" xs="6" sm="6">
                  <v-menu
                    :ref="`tomenu${index}`"
                    v-model="item.menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="item.totime"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="py-1 my-0"
                        v-model="item.totime"
                        aria-required="true"
                        label="End Time"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="item.menu2"
                      v-model="item.totime"
                      full-width
                      :min="item.toDate === item.fromDate ? item.fromtime : ''"
                      format="24hr"
                      @click:minute="updateTime(item, index, 'tomenu')"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</v-col>
</template>

            <v-col cols="12" md="12" lg="12" xs="12" sm="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  color="grey"
                  @click="closeDialog"
                  dense
                  dark
                  small
                >
                  <v-icon left small>mdi-close</v-icon> Cancel
                </v-btn>
                <v-btn
                  color="accent"
                  type="submit"
                  dense
                  small
                >
                  <v-icon left small>mdi-content-save</v-icon> Save
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import InstaCustomDatePicker from '@/components/template/InstaCustomDatePicker'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'AddEditInstagramURL',
  props: {
    instagramDialog: {
      type: Boolean,
      default: false
    },
    instagramItem: {
      type: Object,
      default: () => {}
    },
    requestType: {
      type: String,
      default: null
    },
    franchiseeID: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    InstaCustomDatePicker
  },
  data () {
    const today = new Date()
    return {
      instagramReelsDialog: false,
      isAPiRequested: false,
      franchiseeList: [],
      selectFranchise: '',
      instaUrlsArray: [],
      minStartDate: new Date().toISOString().slice(0, 10),
      maxDate: new Date(today.getFullYear(), today.getMonth() + 1, today.getDate()).toISOString().slice(0, 10),
      minTime: moment(today).format('HH:mm:ss'),
      currentDate: '',
      currentTime: ''
    }
  },
  computed: {
    ...mapGetters({
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    instagramDialog: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.instagramReelsDialog = newVal
        this.updateDateTime()
      }
    },
    instagramItem: {
      handler: function (newVal) {
        if (newVal !== null) {
          let selectedFranchiseeList = null
          if (!newVal.isAccessToAllFranchisees) {
            selectedFranchiseeList = []
            for (let key in newVal.franchiseeID) {
              selectedFranchiseeList.push({ id: key, companyName: newVal.franchiseeID[key] })
            }
          }
          this.instaUrlsArray = []
          this.instaUrlsArray.push({
            id: newVal.id,
            url: newVal.instaUrls,
            invalid: false,
            isError: false,
            franchiseeNames: newVal.isAccessToAllFranchisees ? this.franchiseeList : selectedFranchiseeList,
            fromDate: newVal.startDateAndTime ? moment(newVal.startDateAndTime).format('YYYY-MM-DD') : null,
            toDate: newVal.endDateAndTime ? moment(newVal.endDateAndTime).format('YYYY-MM-DD') : null,
            time1: false,
            menu2: false,
            fromtime: newVal.startDateAndTime ? moment(newVal.startDateAndTime).format('HH:mm:ss') : null,
            totime: newVal.endDateAndTime ? moment(newVal.endDateAndTime).format('HH:mm:ss') : null,
            isSelectAll: newVal.isAccessToAllFranchisees
          })
        }
      },
      deep: true
    },
    requestType: function (newVal) {
      if (newVal === 'create') {
        this.instaUrlsArray = []
        this.createInstaUrlArray()
      }
    }
  },
  async created () {
    this.getFranchiseeList()
    this.setInitialDateTime()
  },

  methods: {

    updateDateTime () {
      const now = new Date()
      this.currentDate = now.toISOString().substr(0, 10)
      this.currentTime = now.toTimeString().substr(0, 5)
    },

    setInitialDateTime () {
      const now = new Date()
      this.currentDate = now.toISOString().substr(0, 10)
      this.currentTime = now.toTimeString().substr(0, 5)

      this.instaUrlsArray.forEach(item => {
        item.fromDate = this.currentDate
        item.fromtime = this.currentTime
        item.toDate = this.currentDate
        item.totime = this.currentTime
      })
    },

    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${CONSTANTS.API_URL}/api/franchisee/active`)
        let data = response.data
        data.rows.forEach(item => {
          this.franchiseeList.push({ id: item.id, companyName: item.companyName })
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    createInstaUrlArray () {
      if (this.instaUrlsArray.length < 10) {
        this.instaUrlsArray.push({
          url: '',
          invalid: false,
          isError: false,
          franchiseeNames: [],
          isFranchiseeError: false,
          fromDate: null,
          toDate: null,
          time1: false,
          menu2: false,
          fromtime: null,
          totime: null,
          isSelectAll: false
        })
      }
    },
    removeInstaUrl: function (index) {
      this.instaUrlsArray.splice(index, 1)
    },
    updateTime (item, index, menuRef) {
      this.$refs[`${menuRef}${index}`][0].save(item[menuRef === 'frommenu' ? 'fromtime' : 'totime'])
      item[menuRef] = false
      this.updateDateTime()
    },

    closeDialog: function () {
      console.log('this.requestType', this.requestType)
      if (this.requestType === 'create') {
        this.instaUrlsArray = []
        this.instagramUrl = ''
      }
      this.$emit('closeInstagramReelsDialog', this.isAPiRequested)
    },
    isInstagramUrl (url) {
      const regex = /^(?:https?|HTTPS?)?:\/\/(?:www\.|WWW\.)?(?:instagram|INSTAGRAM)\.(?:com|COM)\/(?:reel|p)\/[A-Za-z0-9_-]+\/?$/
      return regex.test(url)
    },
    selectAllFranchisee: function (item) {
      if (item.isSelectAll) {
        item.franchiseeNames = []
        this.franchiseeList.forEach(franchiseeObj => {
          item.franchiseeNames.push({ id: franchiseeObj.id, companyName: franchiseeObj.companyName })
        })
      } else {
        item.franchiseeNames = []
      }
    },
    checkAllFranchiseeSelecte: function (item) {
      if (item.franchiseeNames.length === this.franchiseeList.length) {
        item.isSelectAll = true
      } else {
        item.isSelectAll = false
      }
    },

    addUpdateInstagramUrl: async function () {
      try {
        this.isAPiRequested = false
        let payload = {}
        let apiEndpoint = ''
        if (this.requestType === 'edit') {
          let editObj = this.instaUrlsArray[0]
          apiEndpoint += `${CONSTANTS.API_URL}/api/instaMediaPost/updatesInstaMediaPost`
          let isValidUrl = this.isInstagramUrl(editObj.url)
          if (!isValidUrl) {
            return this.errMsg('Please enter a valid URL.')
          } else if (editObj.franchiseeNames.length === 0 && !editObj.isSelectAll) {
            return this.errMsg('Please select franchisee.')
          }
          let franchiseeIDList = []
          if (!editObj.isSelectAll) {
            editObj.franchiseeNames.forEach(obj => {
              franchiseeIDList.push(obj.id)
            })
          }
          let startDate, endDate
          if (editObj.fromDate && !editObj.fromtime) {
            return this.errMsg('Please provide start time.')
          } else if (editObj.toDate && !editObj.totime) {
            return this.errMsg('Please provide end time.')
          } else if (editObj.fromDate && !editObj.toDate) {
            return this.errMsg('Please provide end date.')
          }

          if (editObj.fromDate && editObj.fromtime) {
            startDate = moment(editObj.fromDate + ' ' + editObj.fromtime).format('YYYY-MM-DD HH:mm:ss')
          } else {
            startDate = ''
          }

          if (editObj.toDate && editObj.totime) {
            endDate = moment(editObj.toDate + ' ' + editObj.totime).format('YYYY-MM-DD HH:mm:ss')
          } else {
            endDate = ''
          }

          let EditfrachiseID = franchiseeIDList.filter(item => {
            if (item) return item
          })

          payload.id = editObj.id
          payload.url = editObj.url
          payload.franchiseeID = EditfrachiseID
          payload.academicYearID = this.academicYear.id
          payload.isAccessToAllFranchisees = editObj.isSelectAll
          payload.startDateAndTime = startDate
          payload.endDateAndTime = endDate
        } else {
          apiEndpoint += `${CONSTANTS.API_URL}/api/instaMediaPost/createInstaMediaPost`
          console.log(apiEndpoint)
          let isBlankUrl = false
          let isInvalidUrl = false
          let isRepeatUrl = false
          let checkRepeatedUrl = []
          let filterInstagramUrl = []
          let isAnyFieldBlankValue = false
          let invalidFranchiseeError = false

          this.instaUrlsArray.forEach(item => {
            if (!item.url && !isBlankUrl) {
              item.invalid = false
              item.isError = true
              isBlankUrl = true
            } else if (item.url && !this.isInstagramUrl(item.url) && !isInvalidUrl) {
              item.invalid = true
              isInvalidUrl = true
              item.isError = false
            } else if (item.franchiseeNames.length === 0 && !item.isSelectAll) {
              item.isFranchiseeError = true
              invalidFranchiseeError = true
              item.isError = false
              item.invalid = false
            } else {
              item.invalid = false
              item.isError = false
              isBlankUrl = false
              isInvalidUrl = false
              item.isFranchiseeError = false
              if (checkRepeatedUrl.indexOf(item.url) === -1) {
                item.isError = false
                checkRepeatedUrl.push(item.url)

                let franchiseeIDList = []
                if (!item.isSelectAll) {
                  item.franchiseeNames.forEach(obj => {
                    franchiseeIDList.push(obj.id)
                  })
                }

                let startDate, endDate
                if (item.fromDate && !item.fromtime) {
                  return this.errMsg('Please provide Start Time.')
                } else if (item.toDate && !item.totime) {
                  return this.errMsg('Please provide End Time.')
                } else if (item.fromDate && !item.toDate) {
                  return this.errMsg('Please provide End Date.')
                }

                if (item.fromDate && item.fromtime) {
                  startDate = moment(item.fromDate + ' ' + item.fromtime).format('YYYY-MM-DD HH:mm:ss')
                } else {
                  startDate = ''
                }

                if (item.toDate && item.totime) {
                  endDate = moment(item.toDate + ' ' + item.totime).format('YYYY-MM-DD HH:mm:ss')
                } else {
                  endDate = ''
                }
                let frachiseID = franchiseeIDList.filter(item => {
                  if (item) return item
                })
                filterInstagramUrl.push({
                  'url': item.url,
                  'franchiseeID': frachiseID,
                  'isAccessToAllFranchisees': item.isSelectAll,
                  'academicYearID': this.academicYear.id,
                  'startDateAndTime': startDate,
                  'endDateAndTime': endDate

                })
              } else {
                let getLastIndexOfUrl = checkRepeatedUrl.indexOf(item.url)
                this.instaUrlsArray[getLastIndexOfUrl].isError = true
                item.isError = true
                isRepeatUrl = true
              }
            }
          })
          if (isBlankUrl) {
            return this.errMsg('Please enter Instagram URL.')
          } else if (isInvalidUrl) {
            return this.errMsg('Please enter a valid Instagram URL.')
          } else if (isRepeatUrl) {
            return this.errMsg('Same URL multiple times is not allowed. Please add a unique URL.')
          } else if (isAnyFieldBlankValue) {
            return this.errMsg('Please provide valid Instagram URLs.')
          } else if (invalidFranchiseeError) {
            return this.errMsg('Please select franchisee.')
          } else {
            payload.instaUrls = filterInstagramUrl
          }
        }
        // payload.franchiseeID = this.franchiseeID
        let res = await http.post(apiEndpoint, payload)
        if (res.status === 200) {
          let resMessage = this.requestType === 'edit' ? res.data.message : 'Instagram URL added successfully.'
          this.okMsg(resMessage)
          this.isAPiRequested = true
          this.closeDialog()
        } else {
          this.errMsg(res.data.message)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
